export default function AboutData() {
    return {
        title: "Term vs Permanent Insurance",
        content:
            "Children's whole life insurance is a unique product that can be purchased for children ranging in age from 14 days to 17 years old, at a fixed premium and with no medical exam required. Even if the child is days away from turning 18, this policy is eligible for purchase. Once the child turns 18 – even if the policy was recently acquired – the coverage automatically doubles.",
    }
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/Juve/AboutData.js